import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { handleCallNewsApp, h5PageCount } from 'ThreeTerminal_utils';

class InfoTitle extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    linkShare = share_url => {
        const { type, comments_url, comment_id } = this.props.content;

        h5PageCount([
            {
                behavior: 'action',
                type,
                other: {
                    id: comment_id,
                    ref: encodeURIComponent(document.referrer),
                    url: comments_url,
                },
            },
        ]);
        window.location.href = share_url;
    };

    handleClick = params => {
        const { type, id, url, userId } = params;
        const nodata = '';
        const doc_type = type;
        const aid = id;
        const to_url = url;

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, userId);
    };

    onClick = params => {
        const { share_url, isOnClickDocTitle, isCallNewApp, pageInfo } = params;

        // 呼起app
        if (isCallNewApp) {
            this.handleClick(pageInfo);
        }

        // if (isOnClickDocTitle) {
        //     this.linkShare(share_url);
        // }
    };

    render() {
        const {
            comment_contents,
            share_url,
            isOnClickDocTitle,
            isComment,
            pageInfo,
            comment_relation,
            fromPage,
        } = this.props.content;

        const clickData = {
            share_url,
            isOnClickDocTitle,
            isComment,
            pageInfo,
        };

        const isFromPersonalDetail = fromPage === 'personalDetail';

        return (
            <div>
                {comment_contents ? (
                    <div
                        className={isFromPersonalDetail ? styles.infoWrap : styles.wrap}
                        onClick={isFromPersonalDetail ? () => {} : () => this.onClick(clickData)}>
                        <span className={isFromPersonalDetail ? styles.doc_title : styles.infoTitle}>
                            {comment_contents}
                            {isFromPersonalDetail &&
                                comment_relation &&
                                comment_relation.map((item, index) => {
                                    let itemDom = null;

                                    itemDom = (
                                        <div key={index} className={styles.relation}>
                                            <span className={styles.nickname}>//@{item.nickname}</span>
                                            <span className={styles.contents}>{item.contents}</span>
                                        </div>
                                    );

                                    return itemDom;
                                })}
                        </span>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default InfoTitle;
